module.exports = __webpack_public_path__ + "img/icon-02.90266e50.png";